/* Trustpilot testimonials grid. Markup: sections/trustpilot-testimonials.liquid. */
(function () {
  if (customElements.get('trustpilot-testimonials')) return;

  var API = 'https://api.trustpilot.com/v1/business-units/';

  /* Trustpilot star colour per rating: index = stars */
  var STAR_COLORS = ['#DCDCE6', '#FF3722', '#FF8622', '#FFCE00', '#73CF11', '#00B67A'];
  var AVATAR_BG = ['#E8F3DA', '#E3F2FD', '#FFF3D6', '#F3E8FD', '#FDE7EF', '#E0F5F1'];
  var AVATAR_COLOR = ['#4B7A1C', '#1565C0', '#9A6A00', '#6A3FB5', '#B0275A', '#00796B'];

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str == null ? '' : String(str)));
    return d.innerHTML;
  }

  function starColor(rating) {
    if (rating >= 4.5) return STAR_COLORS[5];
    if (rating >= 3.5) return STAR_COLORS[4];
    if (rating >= 2.5) return STAR_COLORS[3];
    if (rating >= 1.5) return STAR_COLORS[2];
    return STAR_COLORS[1];
  }

  /* fill: 0–1 share of the box that is coloured */
  function starSvg(color, fill) {
    var w = Math.round(24 * fill * 100) / 100;
    return '<svg class="tpt__star" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect width="24" height="24" fill="' + STAR_COLORS[0] + '"/>' +
      (w > 0 ? '<rect width="' + w + '" height="24" fill="' + color + '"/>' : '') +
      '<path d="M12 4.2l1.9 5.6h5.9l-4.8 3.4 1.8 5.6L12 15.4l-4.8 3.4 1.8-5.6-4.8-3.4h5.9z" fill="#fff"/></svg>';
  }

  /* Halves allowed (4.5 → four full boxes and one half box), like Trustpilot */
  function starsHtml(rating) {
    var html = '';
    var color = starColor(rating);
    for (var i = 0; i < 5; i++) {
      html += starSvg(color, Math.max(0, Math.min(1, rating - i)));
    }
    return html;
  }

  function trustLabel(score) {
    if (score >= 4.3) return 'Excellent';
    if (score >= 3.8) return 'Great';
    if (score >= 2.8) return 'Average';
    if (score >= 1.8) return 'Poor';
    return 'Bad';
  }

  function formatNumber(n) {
    return Number(n || 0).toLocaleString('en-AU');
  }

  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function linkHref(links, rel) {
    if (!Array.isArray(links)) return '';
    for (var i = 0; i < links.length; i++) {
      if (links[i].rel === rel && links[i].href) return links[i].href;
    }
    return '';
  }

  var COUNT_KEYS = { 1: 'oneStar', 2: 'twoStars', 3: 'threeStars', 4: 'fourStars', 5: 'fiveStars' };

  class TrustpilotTestimonials extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.apiKey = this.dataset.apiKey;
      this.buid = this.dataset.buid;
      this.perPage = parseInt(this.dataset.perPage, 10) || 12;
      /* Stars shown when no bar filter is active, e.g. "4,5"; empty = all */
      this.baseStars = (this.dataset.baseStars || '').split(',').map(Number).filter(function (n) { return n >= 1 && n <= 5; });
      this.showReplies = this.dataset.showReplies === 'true';
      this.filterable = this.dataset.filterable === 'true';

      this.grid = this.querySelector('[data-tpt-grid]');
      this.statusEl = this.querySelector('[data-tpt-status]');
      this.clearBtn = this.querySelector('[data-tpt-clear]');
      this.errorEl = this.querySelector('[data-tpt-error]');
      this.moreBtn = this.querySelector('[data-tpt-more]');
      this.moreText = this.querySelector('[data-tpt-more-text]');
      this.bars = Array.prototype.slice.call(this.querySelectorAll('.tpt__bar'));

      this.companyName = 'MrSupplement';
      this.counts = null;      /* per-star + total, from the business unit */
      this.stars = 0;          /* active filter, 0 = all */
      this.page = 0;
      this.shown = 0;
      this.hasMore = false;
      this.request = 0;        /* drops responses from an older filter */

      if (!this.apiKey || !this.buid) {
        this.showError();
        return;
      }

      this.moreBtn.addEventListener('click', this.loadNext.bind(this));
      this.clearBtn.addEventListener('click', this.setFilter.bind(this, 0));
      this.grid.addEventListener('click', this.onGridClick.bind(this));

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(this.recheckClamp.bind(this), 150);
      }.bind(this));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.recheckClamp.bind(this));
      if (this.filterable) {
        this.bars.forEach(function (bar) {
          bar.addEventListener('click', function () {
            var s = parseInt(bar.dataset.stars, 10);
            this.setFilter(this.stars === s ? 0 : s);
          }.bind(this));
        }, this);
      } else {
        this.classList.add('tpt--static-bars');
      }

      this.loadSummary();
      this.loadNext();
    }

    api(path, params) {
      var url = new URL(API + encodeURIComponent(this.buid) + path);
      /* apikey as a query param: a custom header would force a CORS preflight */
      url.searchParams.set('apikey', this.apiKey);
      Object.keys(params || {}).forEach(function (k) {
        if (params[k] !== '' && params[k] != null) url.searchParams.set(k, params[k]);
      });
      return fetch(url.toString()).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
    }

    /* ── Summary panel ── */
    loadSummary() {
      this.api('').then(function (bu) {
        var score = bu.score || {};
        var n = bu.numberOfReviews || {};
        if (bu.displayName) this.companyName = bu.displayName;

        this.counts = { total: n.total || 0 };
        for (var s = 1; s <= 5; s++) this.counts[s] = n[COUNT_KEYS[s]] || 0;

        this.renderSummary(score, bu);
        this.updateStatus();
      }.bind(this)).catch(function (err) {
        console.error('[Trustpilot] Summary failed:', err.message);
        /* The heading lives in the summary panel, so only the rating parts go */
        var summary = this.querySelector('[data-tpt-summary]');
        if (!summary) return;
        summary.classList.add('tpt__summary--no-rating');
        summary.querySelector('[data-tpt-score-block]').hidden = true;
        summary.querySelector('[data-tpt-bars]').hidden = true;
      }.bind(this));
    }

    renderSummary(score, bu) {
      var summary = this.querySelector('[data-tpt-summary]');
      if (!summary) return;

      var trustScore = score.trustScore || 0;
      summary.querySelector('[data-tpt-label]').textContent = trustLabel(trustScore);
      summary.querySelector('[data-tpt-score]').textContent = trustScore.toFixed(1);
      var starsEl = summary.querySelector('[data-tpt-score-stars]');
      starsEl.innerHTML = starsHtml(score.stars || trustScore);
      summary.querySelector('[data-tpt-based]').innerHTML =
        'TrustScore ' + esc(trustScore.toFixed(1)) + ' out of 5 · <strong>' + formatNumber(this.counts.total) + ' reviews</strong>';

      var domain = bu.name && bu.name.identifying;
      var write = summary.querySelector('.tpt__write');
      if (domain && write) write.href = 'https://www.trustpilot.com/evaluate/' + encodeURIComponent(domain);

      /* The bars share the per-star counts, so they always add up to the total */
      var sum = 0;
      for (var s = 1; s <= 5; s++) sum += this.counts[s];

      this.bars.forEach(function (bar) {
        var stars = parseInt(bar.dataset.stars, 10);
        var count = this.counts[stars];
        var pct = sum ? (count / sum) * 100 : 0;
        var label = pct > 0 && pct < 1 ? '<1%' : Math.round(pct) + '%';

        bar.querySelector('.tpt__bar-fill').style.width = pct + '%';
        bar.querySelector('[data-tpt-bar-value]').textContent = label;
        bar.setAttribute('aria-label', stars + '-star reviews: ' + formatNumber(count) + ' (' + label + ')' + (this.filterable ? '. Show only these' : ''));
        bar.disabled = !this.filterable || count === 0;
      }, this);
    }

    /* ── Filter ── */
    setFilter(stars) {
      if (stars === this.stars) return;
      this.stars = stars;
      this.page = 0;
      this.shown = 0;
      this.hasMore = false;
      this.request++;

      this.bars.forEach(function (bar) {
        bar.setAttribute('aria-pressed', String(parseInt(bar.dataset.stars, 10) === stars));
      });
      this.clearBtn.hidden = !stars;
      this.errorEl.hidden = true;
      this.grid.innerHTML = this.skeletonHtml(Math.min(this.perPage, 6));
      this.loadNext();
    }

    /* ── Review pages ── */
    loadNext() {
      var req = this.request;
      var nextPage = this.page + 1;

      this.grid.setAttribute('aria-busy', 'true');
      this.moreBtn.disabled = true;
      this.moreText.textContent = 'Loading…';

      this.api('/reviews', {
        perPage: this.perPage,
        page: nextPage,
        stars: this.stars || this.baseStars.join(','),
        orderBy: 'createdat.desc'
      }).then(function (data) {
        if (req !== this.request) return;

        var reviews = data.reviews || [];
        this.page = nextPage;
        this.hasMore = !!linkHref(data.links, 'next-page') && reviews.length > 0;

        if (nextPage === 1) this.grid.innerHTML = '';
        this.appendReviews(reviews);
        this.finishLoad();
      }.bind(this)).catch(function (err) {
        if (req !== this.request) return;
        console.error('[Trustpilot] Reviews failed:', err.message);

        if (this.page === 0) {
          this.showError();
        } else {
          /* Keep the loaded cards and let the visitor try again */
          this.moreText.textContent = 'Try again';
          this.moreBtn.disabled = false;
        }
        this.grid.setAttribute('aria-busy', 'false');
      }.bind(this));
    }

    finishLoad() {
      this.grid.setAttribute('aria-busy', 'false');
      this.moreBtn.hidden = !this.hasMore;
      this.moreBtn.disabled = false;
      this.moreText.textContent = 'Load more reviews';

      if (this.shown === 0) {
        this.grid.innerHTML = '<li class="tpt__empty">No reviews found.</li>';
      }
      this.updateStatus();
    }

    appendReviews(reviews) {
      var frag = document.createDocumentFragment();
      var added = [];

      reviews.forEach(function (review) {
        var li = this.buildCard(review, this.shown);
        if (!li) return;
        frag.appendChild(li);
        added.push(li);
        this.shown++;
      }, this);

      this.grid.appendChild(frag);
      this.checkClamp(added);
    }

    /* "Read more" only where the clamp actually cut text off. Column width changes the
       line count, so this runs again on resize and once web fonts have loaded. */
    checkClamp(cards) {
      cards.forEach(function (li) {
        if (li.classList.contains('is-expanded')) return;
        var text = li.querySelector('.tpt__text');
        var btn = li.querySelector('.tpt__toggle');
        if (text && btn) btn.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    recheckClamp() {
      this.checkClamp(Array.prototype.slice.call(this.grid.querySelectorAll('.tpt__card')));
    }

    buildCard(review, index) {
      var text = (review.text || '').trim();
      var title = (review.title || '').trim();
      if (!text && !title) return null;

      var consumer = review.consumer || {};
      var name = (consumer.displayName || '').trim() || 'Customer';
      var stars = Math.min(5, Math.max(1, parseInt(review.stars, 10) || 5));
      var verified = review.isVerified || review.reviewVerificationLevel === 'verified';
      var avatar = linkHref(consumer.links, 'profile-image');
      var date = formatDate(review.createdAt);
      var ci = index % AVATAR_BG.length;
      var textId = 'tpt-text-' + review.id;

      var html = '<div class="tpt__card-top">' +
        '<span class="tpt__stars" role="img" aria-label="Rated ' + stars + ' out of 5 stars">' + starsHtml(stars) + '</span>' +
        (verified
          ? '<span class="tpt__verified"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="m7.5 12.5 3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified</span>'
          : '') +
        '</div>';

      if (title) html += '<h3 class="tpt__title">' + esc(title) + '</h3>';
      if (text && text !== title) {
        html += '<p class="tpt__text" id="' + esc(textId) + '">' + esc(text).replace(/\n+/g, '<br>') + '</p>' +
          '<button type="button" class="tpt__toggle" aria-expanded="false" aria-controls="' + esc(textId) + '" hidden>Read more</button>';
      }

      html += '<div class="tpt__card-bottom"><div class="tpt__author">' +
        (avatar
          ? '<img class="tpt__avatar" src="' + esc(avatar) + '" alt="" width="36" height="36" loading="lazy">'
          : '<span class="tpt__avatar" style="--tpt-avatar-bg:' + AVATAR_BG[ci] + ';--tpt-avatar-color:' + AVATAR_COLOR[ci] + ';" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span>') +
        '<span class="tpt__author-meta"><span class="tpt__name">' + esc(name) + '</span>' +
        (date
          ? '<a class="tpt__date" href="https://www.trustpilot.com/reviews/' + encodeURIComponent(review.id) + '" target="_blank" rel="noopener"><time datetime="' + esc(review.createdAt) + '">' + esc(date) + '</time></a>'
          : '') +
        '</span></div>';

      var reply = review.companyReply;
      if (this.showReplies && reply && reply.text) {
        html += '<details class="tpt__reply"><summary>' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>' +
          'Reply from ' + esc(this.companyName) +
          '<svg class="tpt__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>' +
          '</summary><p>' + esc(reply.text.trim()).replace(/\n+/g, '<br>') + '</p></details>';
      }
      html += '</div>';

      var li = document.createElement('li');
      li.className = 'tpt__card';
      li.innerHTML = html;
      return li;
    }

    onGridClick(event) {
      var btn = event.target.closest('.tpt__toggle');
      if (!btn) return;
      var card = btn.closest('.tpt__card');
      var open = !card.classList.contains('is-expanded');
      card.classList.toggle('is-expanded', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Show less' : 'Read more';
    }

    updateStatus() {
      if (!this.statusEl || this.page === 0) return;

      var total = 0;
      if (this.counts) {
        if (this.stars) {
          total = this.counts[this.stars];
        } else if (this.baseStars.length) {
          this.baseStars.forEach(function (s) { total += this.counts[s]; }, this);
        } else {
          total = this.counts.total;
        }
      }
      var what = this.stars ? this.stars + '-star reviews' : 'reviews';
      var msg = 'Showing ' + formatNumber(this.shown);
      msg += total ? ' of ' + formatNumber(total) + ' ' + what : ' ' + what;
      this.statusEl.textContent = msg;
    }

    skeletonHtml(n) {
      var card = '<li class="tpt__card tpt__card--skeleton" aria-hidden="true">' +
        '<span class="tpt__sk tpt__sk--stars"></span><span class="tpt__sk tpt__sk--title"></span>' +
        '<span class="tpt__sk"></span><span class="tpt__sk"></span><span class="tpt__sk tpt__sk--short"></span>' +
        '<span class="tpt__sk tpt__sk--author"></span></li>';
      return new Array(n + 1).join(card);
    }

    showError() {
      this.grid.innerHTML = '';
      this.grid.setAttribute('aria-busy', 'false');
      this.errorEl.hidden = false;
      this.moreBtn.hidden = true;
      if (this.statusEl) this.statusEl.textContent = '';
    }
  }

  customElements.define('trustpilot-testimonials', TrustpilotTestimonials);
})();
